import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router';

import { scrollToTarget } from 'src/utils/smoothScroll';

// Href of a "#section" link on a landing page, respecting the app base path
export const anchorHref = (hash, homePath = '/') => `${import.meta.env.BASE_URL}${homePath.replace(/^\//, '')}${hash}`;

// Smooth scroll to "#section" links on the landing page, navigate there from other pages
const useAnchor = (homePath = '/') => {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  return useCallback(
    (event) => {
      const { hash } = new URL(event.currentTarget.href);
      event.preventDefault();

      if (pathname !== homePath) {
        navigate(hash === '#hero' ? homePath : `${homePath}${hash}`);
        return;
      }
      scrollToTarget(hash, { offset: hash === '#hero' ? 0 : -20 });
    },
    [pathname, navigate, homePath]
  );
};

export default useAnchor;
